import axios from 'axios';
import { API_URL } from './Constant';

/* =========================
   AXIOS INSTANCE (SIMPLE)
========================= */
export const axiosConfig = axios.create({
    baseURL: API_URL,
    responseType: "json",
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

/* 🔐 Token interceptor */
axiosConfig.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

/* =========================
   API HELPERS (JSON)
========================= */

// GET
export const getData = async (endpoint) => {
    try {
        const res = await axiosConfig.get(endpoint);
        return res.data;
    } catch (err) {
        return err?.response?.data;
    }
};

// POST (JSON)
export const postData = async (endpoint, body) => {
    try {
        const res = await axiosConfig.post(endpoint, body);
        return res.data;
    } catch (err) {
        return err?.response?.data;
    }
};

// PUT
export const putData = async (endpoint, data) => {
    try {
        const res = await axiosConfig.put(endpoint, data);
        return res.data;
    } catch (err) {
        return err?.response?.data;
    }
};

// DELETE
export const deleteData = async (endpoint) => {
    try {
        const res = await axiosConfig.delete(endpoint);
        return res.data;
    } catch (err) {
        return err?.response?.data;
    }
};

/* =========================
   📁 EXCEL / FILE UPLOAD
========================= */

export const uploadExcel = async (endpoint, formData) => {
    try {
        const token = localStorage.getItem('token');

        const res = await axios.post(`${API_URL}${endpoint}`, formData, {
            headers: {
                Authorization: token ? `Bearer ${token}` : "",
                // ❌ Content-Type mat do (browser khud set karega)
            },
            withCredentials: true,
        });

        return res.data;
    } catch (err) {
        return err?.response?.data;
    }
};
